/**
 * 从举报原因树中根据 reasonId 搜索到指定的原因列表
 * @param {Array} reasonTreeRoot 举报原因树根
 * @param {String} reasonId 原因 reasonId
 */
export function searchReasonList(reasonTreeRoot, reasonId) {
  if (!reasonId) return reasonTreeRoot || []
  if (!reasonTreeRoot) return []
  let res = null
  function find(tree, id) {
    tree.forEach(item => {
      if (item.reasonId == id) {
        res = item.reasonList
      } else {
        find(item.reasonList, id)
      }
    })
  }

  reasonTreeRoot.forEach(item => {
    find(item, reasonId)
  })

  return res
}

/**
 * 根据原因 reasonId 获取指定原因配置
 * @param {Array} reasonTreeRoot 举报原因树
 * @param {String} reasonId 原因 reasonId
 */
export function getReason(reasonTreeRoot, reasonId) {
  if (!reasonTreeRoot || !reasonId) return {}

  for (const item of reasonTreeRoot) {
    if (item.reasonId === reasonId) {
      return item
    }
    const res = getReason(item.reasonList, reasonId)
    if (res) return res
  }

  return {}
}

/**
 * 根据原因 reasonId 找父级
 * @param {Array} reasonTreeRoot 举报原因树
 * @param {String} reasonId 原因 reasonId
 */
export function findParentReason(reasonTreeRoot, curList) {
  if (!reasonTreeRoot || !curList) return []
  let res = []
  function find(tree, _id) {
    tree.reasonList.forEach(item => {
      if (item.reasonList.every((t, index) => curList[index].reasonId === t.reasonId) && item.reasonList.length) {
        res = tree
      } else {
        find(item, curList)
      }
    })
  }
  find(reasonTreeRoot, curList)
  return res
}

/**
 * 格式化数据，添加层级标识 1，2，3
 * @param {Array} reasonTreeRoot 举报原因树
 * 根据from拆分数据
 */
export function formatReason(reasonTreeRoot, from) {
  if (!reasonTreeRoot) return []
  const rawData = []
  function addLevel(tree, level) {
    return tree.map(item => {
      if (!item.reasonList.length) {
        return { ...item, level, isLeaf: true }
      } else {
        return { ...item, level, isLeaf: false, reasonList: addLevel(item.reasonList, level + 1) }
      }
    })
  }
  if (from == '1' || from == '14') {
    reasonTreeRoot[3] = reasonTreeRoot[0]
    reasonTreeRoot.splice(0, 2)
  } else if (['2', '3', '4'].includes(from)) {
    reasonTreeRoot[3] = reasonTreeRoot.slice(0, 4)
    reasonTreeRoot.splice(0, 3)
  }
  reasonTreeRoot.forEach(item => {
    if (item.reasonId == '1' && (from == 1 || from == 14)) {
      rawData.push(item.reasonList)
    } else if (Array.isArray(item)) {
      rawData.push(item)
    } else {
      rawData.push([item])
    }
  })
  return rawData.map(item => {
    return addLevel(item, 1)
  })
}
